import { PaymentRequestStatusType } from 'types/cashFlow'

export const PAYABLE_REQUEST_STATUS_VALUES: PaymentRequestStatusType[] = ['requested', 'expired', 'viewed']
